var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPermissionsBoundary24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2456 13.1303C10.7827 14.4176 9.55104 15.3382 8.10433 15.3382C6.26127 15.3382 4.76717 13.8441 4.76717 12.001C4.76717 10.1579 6.26127 8.66385 8.10433 8.66385C9.57571 8.66385 10.8247 9.61609 11.2686 10.9379H18.2917C18.3805 10.9379 18.466 10.971 18.5318 11.0307L18.9988 11.4547C19.2946 11.7233 19.3126 12.1823 19.0388 12.4732L17.6409 13.9581C17.5052 14.1024 17.278 14.1086 17.1346 13.972L16.2508 13.1303L15.3547 13.9837C15.2161 14.1157 14.9982 14.115 14.8605 13.9823L13.9766 13.1303L13.2644 13.9442C13.1322 14.0953 12.9016 14.1078 12.7538 13.9719L11.8387 13.1303H11.2456ZM8.10433 13.7022C7.1648 13.7022 6.40316 12.9405 6.40316 12.001C6.40316 11.0615 7.1648 10.2998 8.10433 10.2998C9.04386 10.2998 9.8055 11.0615 9.8055 12.001C9.8055 12.9405 9.04386 13.7022 8.10433 13.7022Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 2.25C1.34359 2.25 1.00781 2.58579 1.00781 3L1.00791 21C1.00791 21.4142 1.3437 21.75 1.75792 21.75C2.17213 21.75 2.50791 21.4142 2.50791 21L2.50781 3C2.50781 2.58578 2.17202 2.25 1.75781 2.25Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.242 2.25123C21.8278 2.25123 21.492 2.58702 21.492 3.00123L21.4921 21.0012C21.4921 21.4154 21.8279 21.7512 22.2421 21.7512C22.6563 21.7512 22.9921 21.4154 22.9921 21.0012L22.992 3.00122C22.992 2.58701 22.6562 2.25123 22.242 2.25123Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 2.25122C1.34359 2.25122 1.00781 2.58701 1.00781 3.00122L1.00791 21.0012C1.00791 21.4154 1.3437 21.7512 1.75792 21.7512C2.17213 21.7512 2.50791 21.4154 2.50791 21.0012L2.50781 3.00121C2.50781 2.587 2.17202 2.25122 1.75781 2.25122Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPermissionsBoundary24);
export default __webpack_public_path__ + "static/media/icon_permissions_boundary_24.19b0cf05f7e18e8dde9e6e1901b12aa4.svg";
export { ForwardRef as ReactComponent };